<style src="../css/head.css"></style>

<style src="../css/detail.css"></style>

<template>
  <div>
    <Head-section></Head-section>
    <br> 
    <div class="container">
     
    <div class="mt-3">
         <div class="mt-4">
          <b-card no-body class="overflow-hidden">
            <b-row no-gutters>
              <b-col md="6">
                <b-card-img
                  src="https://bluedio.com/img/2020/06/24/5aae876a9ca941e28354dea532664c34.jpg"
                  alt="Gift Box"
                  class="rounded-0"
                ></b-card-img>
              </b-col>
              <b-col md="6">
                <b-card-body title class="card-body-sytle">
<b-card-text v-if="lan=='cn'">
                   <H1 align ="center">礼品盒</H1>
<br>
参加社区论坛赢取积分，并在“礼物盒”中消费。
<br> <br>
赢得机会越多，您花的学分越多。
<br> <br>
新奖品会定期发布，因此请经常回来查看您的收藏夹！
</b-card-text>
<b-card-text v-else-if="lan=='de'">
                   <H1 align = "center"> Geschenkbox </H1>
<br>
Nehmen Sie am Community-Forum teil, um Credits zu gewinnen, und geben Sie sie in unserer Geschenkbox aus.
<br> <br>
Wo Ihre Gewinnchancen steigen, je mehr Credits Sie ausgeben.
<br> <br>
Regelmäßig werden neue Preise veröffentlicht. Schauen Sie also regelmäßig vorbei, um Ihre Favoriten zu finden!
</b-card-text>
<b-card-text v-else-if="lan=='fr'">
                   <H1 align = "center"> Coffret cadeau </H1>
<br>
Participez au forum communautaire pour gagner des crédits et dépensez-les dans notre coffret cadeau.
<br> <br>
Lorsque vos chances de gagner augmentent, plus vous dépensez de crédits.
<br> <br>
De nouveaux prix sont affichés régulièrement, alors revenez souvent pour trouver vos favoris!
</b-card-text>
<b-card-text v-else-if="lan=='es'">
                   <H1 align = "center"> Caja de regalo </H1>
<br>
Participa en el foro de la comunidad para ganar créditos y gástalos en nuestra caja de regalo.
<br> <br>
Donde aumentan tus posibilidades de ganar, más créditos gastas.
<br> <br>
Los nuevos premios se publican regularmente, ¡así que vuelve a menudo para encontrar tus favoritos!
</b-card-text>
<b-card-text v-else-if="lan=='it'">
                   <H1 align = "center"> Confezione regalo </H1>
<br>
Partecipa al forum della community per vincere crediti e spenderli nella nostra confezione regalo.
<br>
Dove le tue possibilità di vincere aumentano, più crediti spendi.
<br>
Nuovi premi vengono pubblicati regolarmente, quindi torna spesso per trovare i tuoi preferiti!
</b-card-text>
<b-card-text v-else-if="lan=='ru'">
                   <H1 align = "center"> Подарочная коробка </H1>
<br>
Примите участие в форуме сообщества, чтобы выиграть кредиты и потратить их в нашей подарочной коробке.
<br> <br>
Чем больше ваши шансы на победу, тем больше кредитов вы тратите.
<br> <br>
Новые призы публикуются регулярно, поэтому заходите почаще, чтобы найти свои любимые!
</b-card-text>
<b-card-text v-else-if="lan=='tr'">
                   <H1 align = "center"> Hediye Kutusu </H1>
<br>
Kredi Kazanmak için topluluk forumuna katılın ve Hediye Kutumuza harcayın.
<br>
Kazanma şansınız nerede daha fazla Kredi harcarsanız.
<br>
Yeni ödüller düzenli olarak yayınlanmaktadır, bu yüzden favorilerinizi bulmak için sık sık tekrar kontrol edin!
</b-card-text>
<b-card-text v-else-if="lan=='pl'">
                   <H1 align = "center"> Pudełko upominkowe </H1>
<br>
Weź udział w forum społeczności, aby wygrać kredyty i wydaj je w naszym pudełku prezentowym.
<br> <br>
Tam, gdzie Twoje szanse na wygraną rosną, tym więcej wydasz Kredyty.
<br> <br>
Nowe nagrody są publikowane regularnie, więc często sprawdzaj, aby znaleźć swoje ulubione!
</b-card-text>
<b-card-text v-else-if="lan=='jp'">
                   <H1 align = "center">ギフトボックス</H1>
<br>
クレジットを獲得するためにコミュニティフォーラムに参加し、ギフトボックスでそれらを使います。
<br> <br>
勝つチャンスが増えると、クレジットが増えます。
<br> <br>
新しい賞品は定期的に投稿されますので、頻繁にチェックしてお気に入りを見つけてください！
</b-card-text>
<b-card-text v-else-if="lan=='kr'">
                   <H1 align = "center"> 선물 상자 </H1>
<br>
커뮤니티 포럼에 참여하여 크레딧을 획득하고 선물 상자에 보내십시오.
<br> <br>
당신이 이길 수있는 기회는 더 많은 크레딧을 소비합니다.
<br> <br>
새로운 상품은 정기적으로 게시되므로 자주 확인하여 즐겨 찾기를 찾아보십시오!
</b-card-text>
                  <b-card-text v-else>
                  <H1 align="center">Gift Box</H1>
<br>
Participate in the community forum to Win Credits , and Spend them in our Gift Box .
<br><br>
Where your chances to win increase the more Credits you spend . 
<br><br>
New prizes are posted regularly , so check back often to find your favorites !
                  </b-card-text>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </div>
         
        </div>
        </div>
    <Foot-section></Foot-section>
  </div>
</template>

<script>
import HeadSection from "./HeadSection.vue";
import FootSection from "./FootSection.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "GiftBox",
  components: {
    HeadSection,
    FootSection
  },
  metaInfo() {
    return {
       title: this.$t("message.Bluedio_Mall") + " | Gift Box",
       titleTemplate: "%s",
      meta: [
         {
          name: "keywords",
          content: "Gift Box",
        }
      ],
    };
  },
  data() {
    return {
      
    };
  },
   created() {
    let language = this.$route.params.language;
    if(this.$store.state.lan_array.indexOf(language) == -1){
      this.toHome();
    }
  },
  computed: mapGetters(["lan", "lan_array"]),

  watch: {
  },
  methods: {
     toHome() {
      let nameHome = this.lan + "home";
      this.$router.replace({
        name: nameHome
      });
    },
  },
};
</script>
